import { createFileRoute } from '@tanstack/react-router';
import { ApproveLinkPage } from '@/features/approvals/pages/approve-link-page';

/** Public (no session): the signed link in the approver's LINE message. */
export const Route = createFileRoute('/approve/$token')({ component: ApproveLinkPage });
